import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img
              src="https://customer-assets.emergentagent.com/job_4751d43d-1951-4426-81ab-b42054c9ab61/artifacts/jxhjc4ws_Screenshot%202026-03-03%20075258.png"
              alt="Ascend Digital"
              className="h-10 w-10 object-contain"
            />
            <span className="text-xl font-semibold text-[#2d4f4f] tracking-tight">Ascend Digital</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('capabilities')}
              className="text-gray-700 hover:text-[#2d4f4f] transition-colors duration-200 font-medium"
            >
              Capabilities
            </button>
            <button
              onClick={() => scrollToSection('work')}
              className="text-gray-700 hover:text-[#2d4f4f] transition-colors duration-200 font-medium"
            >
              Work
            </button>
            <button
              onClick={() => scrollToSection('process')}
              className="text-gray-700 hover:text-[#2d4f4f] transition-colors duration-200 font-medium"
            >
              Process
            </button>
            <button
              onClick={() => scrollToSection('technologies')}
              className="text-gray-700 hover:text-[#2d4f4f] transition-colors duration-200 font-medium"
            >
              Tech
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#2d4f4f] hover:bg-[#1a3a3a] text-white transition-colors duration-300"
            >
              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-[#2d4f4f] transition-colors"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 bg-white border-t border-gray-100">
            <nav className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('capabilities')}
                className="text-left px-4 py-2 text-gray-700 hover:text-[#2d4f4f] hover:bg-gray-50 transition-colors duration-200 font-medium"
              >
                Capabilities
              </button>
              <button
                onClick={() => scrollToSection('work')}
                className="text-left px-4 py-2 text-gray-700 hover:text-[#2d4f4f] hover:bg-gray-50 transition-colors duration-200 font-medium"
              >
                Work
              </button>
              <button
                onClick={() => scrollToSection('process')}
                className="text-left px-4 py-2 text-gray-700 hover:text-[#2d4f4f] hover:bg-gray-50 transition-colors duration-200 font-medium"
              >
                Process
              </button>
              <button
                onClick={() => scrollToSection('technologies')}
                className="text-left px-4 py-2 text-gray-700 hover:text-[#2d4f4f] hover:bg-gray-50 transition-colors duration-200 font-medium"
              >
                Tech
              </button>
              <div className="px-4">
                <Button
                  onClick={() => scrollToSection('contact')}
                  className="w-full bg-[#2d4f4f] hover:bg-[#1a3a3a] text-white transition-colors duration-300"
                >
                  Get Started
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
